<template>
	<div class="loadHead">
		<div class="title">Load # <span>{{ id }}</span></div>
		<div class="contract_btn">
			<button :disabled="isLoadLength" @click="onRemoveLoad" type="button" class="mainBtn mainBtn-text">
	          <span class="btnIco">
		          <svg-sprite icon-id="deleteItem" width="20" height="20"></svg-sprite>
	          </span>
				<span class="btnText">Remove this load</span>
			</button>
		</div>
	</div>
</template>

<script>
export default {
	name: "LoadHead",
	props: {
		id: Number,
		isLoadLength: Boolean,
	},
	methods: {
		onRemoveLoad() {
			this.$emit('updateRemoveLoad');
		},
	},
};
</script>

<style scoped lang="scss">
@import "loadHead";
</style>
